import { render, staticRenderFns } from "./CaseClipItem.vue?vue&type=template&id=81f3629a"
import script from "./CaseClipItem.vue?vue&type=script&lang=js"
export * from "./CaseClipItem.vue?vue&type=script&lang=js"
import style0 from "./CaseClipItem.vue?vue&type=style&index=0&id=81f3629a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports